import axios from '@/config/api.request'

export default {
    // 保存加密货币团购记录
    saveCryptoGroupRecord(cryptoGroupRecord) {
        return axios.request({
            url: '/crypto/group/record/save',
            method: 'post',
            data: cryptoGroupRecord
        })
    },
}